import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { GetUserNotificationsResponseType } from '../types';

export const getUserNotifications = async () => {
  const url = '/api/v2/auth/user/notifications';

  const { data } =
    await apiAuthClient.get<GetUserNotificationsResponseType>(url);

  return data;
};
